import { useEffect } from "react";

export function useKeyboardNavigation({
    swipeCardRef,
    isFiltersOpen,
    isImageViewerOpen,
}) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Prevent swiping if filters are open or image dialog is open
            if (isFiltersOpen || isImageViewerOpen) return;

            // Prevent swiping if user is typing in an input
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

            if (e.key === 'ArrowLeft') {
                swipeCardRef.current?.triggerSwipe('left');
            } else if (e.key === 'ArrowRight') {
                swipeCardRef.current?.triggerSwipe('right');
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isFiltersOpen, isImageViewerOpen, swipeCardRef]);
}
